export const themeColors = [
	"#7367f0",
	"#f43f5e",
	"#3b82f6",
	"#14b8a6",
	"#eab308",
];
